const NotionSelectColors = {
    red: "rgba(255,115,105,0.5)",
    pink: "rgba(226,85,161,0.5)",
    purple: "rgba(154,109,215,0.5)",
    blue: "rgba(82,156,202,0.5)",
    green: "rgba(77,171,154,0.5)",
    yellow: "rgba(255,220,73,0.5)",
    orange: "rgba(255,163,68,0.5)",
    brown: "rgba(147,114,100,0.5)",
    gray: "rgba(151,154,155,0.5)",
};

export default NotionSelectColors;
